<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" class="demo-inline-form" :model="search_form">
          <el-form-item label="乐刷商户号">
            <el-input
              style="width:160px;"
              v-model="search_form.merchantId"
            ></el-input>
          </el-form-item>
          <el-form-item label="银联商编">
            <el-input
              style="width:160px;"
              v-model="search_form.unionMchId"
            ></el-input>
          </el-form-item>
          <el-form-item label="受理状态">
            <el-select v-model="search_form.acceptStatus" clearable>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="入驻成功" :value="1"></el-option>
              <el-option label="入驻失败" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttonSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              download="银联活动商户信息导出.csv"
              icon="el-icon-download"
              @click.native="buttonExport"
              label="导出"
              :loading="exportLoading"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        :header-cell-style="{background:'#FAFAFA'}"
        v-loading="tableLoading"
        :data="list">
        <el-table-column
          prop="fMerchantId"
          label="乐刷商户号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fBindUnionMchId"
          label="银联营销商户号"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fMerNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="银联商编"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fBindUnionMchId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fAgentId1g"
          label="一级代理商编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="直属代理商编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="statusStr"
          label="受理状态"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="init_merchant"
              type="text"
              v-if="scope.row.fStatus === 1 || scope.row.fStatus === 4"
              lable="报备"
              @click.native="submitInfo(scope.row)"></auth-button>
            <auth-button
              opt="edit"
              type="text"
              v-else-if="scope.row.fStatus === 3"
              label="编辑活动资料"
              @click.native="editActivityData(scope.row)"></auth-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { unionActivityMerchantList, unionActivityMerchantInit, exportUnionMerchant } from '@/api/merchant'
export default {
  name: 'UnionPayMerchant',
  data () {
    return {
      search_form: {
        merchantId: '',
        unionMchId: '',
        acceptStatus: '',
        pageNo: 1,
        Count: 0
      },
      checkLoading: false, // 查询按钮
      tableLoading: false, // 表格加载
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      list: [], // 信息列表
      salesNum: 0, // 条数
      submitLoading: false, // 报备按钮
      exportLoading: false, // 导出按钮加载
      agentId: ''
    }
  },
  mounted () {
    this.getList()
    this.agentId = this.$store.getters.userId
  },
  methods: {
    /**
       * @description 搜索点击
       */
    buttonSearch () {
      this.search_form.pageNo = 1
      this.search_form.Count = 0
      this.getList()
    },
    /**
       * @description 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.salesNum
      this.search_form.pageNo = page
      this.search_form.Count = totalCount
      this.getList()
    },
    /**
       * @description 获取列表
       */
    getList () {
      this.tableLoading = true
      this.search_form.merchantId = this.search_form.merchantId && this.search_form.merchantId.replace(/ /g, '')
      this.search_form.FMerchantName = this.search_form.FMerchantName && this.search_form.FMerchantName.replace(/ /g, '')
      var data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      unionActivityMerchantList(data).then((data) => {
        this.checkLoading = false
        if (data.error_code !== '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.tableLoading = false
        } else {
          this.tableLoading = false
          this.paginations.total = data.totalCount
          this.list = data.list
          this.salesNum = data.totalCount
        }
      }).catch(() => {
      })
    },
    /**
       * @description 清除对象中无值属性
       * @param  {object} search 需要格式化的对象
       */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * @description 报备提交接口
       * @param  {object} row 选择的行数据对象
       */
    submitInfo (row) {
      console.log(row)
      const that = this
      let data = {
        id: row.fId
      }
      data = qs.stringify(data)
      this.submitLoading = true
      unionActivityMerchantInit(data).then((data) => {
        that.submitLoading = false
        if (data.error_code !== '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.$message({
            showClose: true,
            message: '报名成功',
            type: 'success'
          })
          this.getList()
        }
      }).catch(() => {
        that.$message({
          showClose: true,
          message: '请求超时，请重新登录',
          type: 'error'
        })
      })
    },
    /**
       * 导出按钮
       */
    buttonExport () {
      // 当点击查询时，显示第一页
      this.search_form.pageNo = 1
      this.exportLoading = true
      this.exportList()
    },
    exportList () {
      var data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      exportUnionMerchant(data).then(response => {
        this.exportLoading = false
        const nowDate = new Date()
        const timeString = nowDate.getFullYear() + '' +
            (((nowDate.getMonth() + 1) < 10) ? ('0' + (nowDate.getMonth() + 1)) : (nowDate.getMonth() + 1)) +
            ((nowDate.getDate() < 10) ? ('0' + nowDate.getDate()) : (nowDate.getDate())) +
            ((nowDate.getHours() < 10) ? ('0' + nowDate.getHours()) : (nowDate.getHours())) +
            ((nowDate.getMinutes() < 10) ? ('0' + nowDate.getMinutes()) : (nowDate.getMinutes())) +
            ((nowDate.getSeconds() < 10) ? ('0' + nowDate.getSeconds()) : (nowDate.getSeconds()))
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '银联商户信息_' + this.agentId + '_' + timeString + '.csv')
        document.body.appendChild(link)
        link.click()
      })
    },
    // 编辑活动资料
    editActivityData (row) {
      const query = {
        fMerchantId: row.fMerchantId,
        fAgentId: row.fBindUnionMchId,
        fBindUnionMchId: row.fMerNo
      }
      this.$router.push({ path: '/Merchant/activityMerchant/activityData', query })
      const picForm = {
        unionpayDoorPhoto: row.fUnionpayDoorPhoto || '',
        unionpayCashier: row.fUnionpayCashier || '',
        unionpayLightEquipment: row.fUnionpayLightEquipment || '',
        unionpayVoiceEquipment: row.fUnionpayVoiceEquipment || ''
      }
      localStorage.setItem('activeForm', JSON.stringify(query))
      localStorage.setItem('picForm', JSON.stringify(picForm))
    }
  }
}
</script>

<style scoped>
  .list{
    padding-left: 16px;
  }
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }
  .pagination {
    display: inline-block;
  }
</style>
